import { render, staticRenderFns } from "./BusinessCardReaderRegistration.vue?vue&type=template&id=6d7a8bf2"
import script from "./BusinessCardReaderRegistration.vue?vue&type=script&lang=js"
export * from "./BusinessCardReaderRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports